/**
 * @file 单价设置页
 */
<template>
  <div class="p-price-setting">
    <div class="p-price-setting__info">
      <plv-tips>
        单价设置仅影响金额结算，默认单价设置会跟随集团账单单价<br />
        此处单价仅影响该分账号金额，不会改变集团账号主账号系统结算
      </plv-tips>
    </div>
    <div v-if="liveForm.length > 0" class="p-price-setting__form">
      <h3 class="p-price-setting__title">直播</h3>
      <div class="p-price-setting__live__form">
        <plv-form
          ref="form"
          label-width="220px"
        >
          <plv-row
            v-for="(itemArray, index) of liveForm"
            :key="index"
            :gutter="20"
            type="flex"
          >
            <plv-col v-for="item of itemArray" :key="item.itemId" :span="10">
              <plv-form-item :label="item.name">
                <plv-input-number v-model="item.univalence" size="medium" :max="100000000">
                  <template slot="suffix">
                    <div class="g-input-append">{{ item.univalenceUnit }}</div>
                  </template>
                </plv-input-number>
              </plv-form-item>
            </plv-col>
          </plv-row>
        </plv-form>
      </div>
    </div>
    <div v-if="vodForm.length > 0" class="p-price-setting__form">
      <h3 class="p-price-setting__title">点播</h3>
      <div class="p-price-setting__vod__form">
        <plv-form
          ref="form"

          label-width="220px"
        >
          <plv-row
            v-for="(itemArray, index) of vodForm"
            :key="index"
            :gutter="20"
            type="flex"
          >
            <plv-col v-for="item of itemArray" :key="item.itemId" :span="10">
              <plv-form-item :label="item.name">
                <plv-input-number v-model="item.univalence" size="medium" :max="100000000">
                  <template slot="suffix">
                    <div class="g-input-append">{{ item.univalenceUnit }}</div>
                  </template>
                </plv-input-number>
              </plv-form-item>
            </plv-col>
          </plv-row>
        </plv-form>
      </div>
    </div>
    <div v-if="vClassForm.length > 0" class="p-price-setting__form">
      <h3 class="p-price-setting__title">研讨会</h3>
      <div class="p-price-setting__vClass__form">
        <plv-form
          ref="form"
          label-width="220px"
        >
          <plv-row
            v-for="(itemArray, index) of vClassForm"
            :key="index"
            :gutter="20"
            type="flex"
          >
            <plv-col v-for="item of itemArray" :key="item.itemId" :span="10">
              <plv-form-item :label="item.name">
                <plv-input-number v-model="item.univalence" size="medium" :max="100000000">
                  <template slot="suffix">
                    <div class="g-input-append">{{ item.univalenceUnit }}</div>
                  </template>
                </plv-input-number>
              </plv-form-item>
            </plv-col>
          </plv-row>
          <plv-row
            :gutter="20"
            type="flex"
          >
            <plv-col :span="10">
              <plv-form-item>
                <plv-button @click="handleSubmit">保存</plv-button>
              </plv-form-item>
            </plv-col>
          </plv-row>
        </plv-form>
      </div>
    </div>
  </div>
</template>

<script>
import chunk from 'lodash.chunk';
import flattenDeep from 'lodash.flattendeep';
import cloneDeep from 'lodash.clonedeep';
import { productionEnum } from '@/utils/type';
export default {
  data() {
    return {
      unionId: -1,
      liveForm: [],
      vodForm: [],
      vClassForm: []
    };
  },
  created() {
    const { params: { id } } = this.$route;
    if (id) this.unionId = id;
    id && this.getBillItem(id);
  },
  methods: {
    async  getBillItem(unionId) {
      this.$emit('loading');
      try {
        const res = await this.$store.dispatch('account/getBillItems', unionId);
        res.forEach(item => {
          item.univalence = item.univalence / 100000;
          if (item.production === productionEnum.Live) {
            this.liveForm.push(item);
          } else if (item.production === productionEnum.Vod) {
            this.vodForm.push(item);
          } else if (item.production === productionEnum.VClass) {
            this.vClassForm.push(item);
          }
        });

        this.liveForm = chunk(this.liveForm, 2);

        this.vodForm = chunk(this.vodForm, 2);

        this.vClassForm = chunk(this.vClassForm, 2);
      } finally {
        this.$emit('cancelLoading');
      }

    },
    async handleSubmit() {
      if (!this.unionId) return;
      this.$emit('loading');
      const liveForm = flattenDeep(this.liveForm);
      const vodForm = flattenDeep(this.vodForm);
      const vClassForm = flattenDeep(this.vClassForm);
      const itemList = cloneDeep([...liveForm, ...vodForm, ...vClassForm]);
      itemList.map(item => {
        item.univalence = item.univalence * 100000;
      });
      try {
        await this.$store.dispatch('account/updateBillItems', {
          itemList,
          unionId: this.unionId
        });
        this.$toast.success('保存成功');
      } finally {
        this.$emit('cancelLoading');
      }

    }
  }
};
</script>

<style lang="scss">
.p-price-setting {
  padding: 0 18px;
  padding-bottom: 50px;
  .p-price-setting__form__flex {
    display: flex;
  }
  .p-price-setting__form {
    margin-top: 20px;
    &:nth-last-child(1) {
      margin-bottom: 20px;
    }
  }
}
</style>
